import { BASE_API_URL, LANG, SITE } from '../config';
import fakeApi from './fake-api';
import { FeatureDisplay, Store, StoreDisplay } from '../types';
import { getLangVar, getStoreBalloonOptions } from './misc';

const isDevMode = process.env.NODE_ENV === 'development';
//const isDevMode = false;
export const encodeGet = (params: GetObject) => {
    return Object.entries(params)
        .map(([key, value]) => [key, encodeURIComponent(value)].join('='))
        .join('&');
};

export interface GetObject {
    [key: string]: string;
}

const _fetchJson = (url: string, get: GetObject = {}, params: RequestInit = {}) => {
    const fullParams = {
        ...params,
        headers: {
            ...params.headers,
        },
    };
    let urlParams = encodeGet(get);
    if (urlParams) {
        urlParams = '?' + urlParams;
    }
    return fetch(BASE_API_URL + url + urlParams, fullParams).then((res) => {
        if (!res.ok) {
            throw res;
        }
        return res.json();
    });
};
const fetchJson = isDevMode ? fakeApi : _fetchJson;

// const postJson = (url: string, get: GetObject = {}, body: any, params: RequestInit = {}) => {
//     return fetchJson(url, get, {
//         mode: 'cors',
//         headers: {
//             'Content-Type': 'application/json',
//             ...params.headers,
//         },
//         method: 'POST',
//         body: JSON.stringify(body),
//         ...params,
//     });
// };
const mapStore = (s: StoreDisplay): Store => {
    let searchable = s.city || '';
    for (const lang of Object.values(s.langs)) {
        searchable += lang.name || '';
        searchable += lang.address || '';
    }
    searchable = searchable.toLowerCase();
    const featuresByCode: Record<string, FeatureDisplay> = {};
    for (const f of s.features) {
        featuresByCode[f.code] = f;
    }
    const hintContent = getLangVar(s, 'name') || '';
    const balloonContent = getStoreBalloonOptions(s);

    return { ...s, searchable, featuresByCode, hintContent, balloonContent };
};
const getNormalizedName = (s: Store) =>
    getLangVar(s, 'name')
        ?.replaceAll(/["()«»]/g, '')
        .toLowerCase() || '';

const sortStores = (a: Store, b: Store) => {
    if (a.product?.stock && !b.product?.stock) {
        return -1;
    }
    if (b.product?.stock && !a.product?.stock) {
        return 1;
    }
    if (a.product?.stock && b.product?.stock) {
        if (a.product.dateArrived !== b.product.dateArrived) {
            return (
                new Date(b.product.dateArrived || 0).getTime() -
                new Date(a.product.dateArrived || 0).getTime()
            );
        }
        if (a.product.deliveryDays !== b.product.deliveryDays) {
            return a.product.deliveryDays - b.product.deliveryDays;
        }
    }
    const nameA = getNormalizedName(a);
    const nameB = getNormalizedName(b);
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
};

export const fetchStores = async (product: string | null): Promise<Store[]> => {
    const get: any = {
        lang: LANG,
        site: SITE,
    };
    if (product) {
        get.product = product;
    }
    const stores = await fetchJson('/', get);
    return stores.filter(getNormalizedName).map(mapStore).sort(sortStores);
};
